import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const PricingUpdateStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-bottom: 15px;

  ${mediaQuery.xs} {
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  a,
  .dropdown-menu a {
    align-items: center;
    display: inline-flex;
    flex-direction: row;
    gap: 5px;
  }

  .dropdown-menu {
    width: 100%;
    a {
      padding-left: 10px;
      pointer-events: none;
    }
  }

  svg {
    --size: 16px;
    height: var(--size);
    width: var(--size);
  }

  .dropdown-toggle {
    border: none;
  }

  .pricing-tool-updates {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 5px;

    ${mediaQuery.xs} {
      flex-direction: column;
    }

    > span {
      align-items: center;
      display: inline-flex;
      gap: 10px;
    }

    > span:not(:last-child)::after {
      content: '|';
      margin-left: 3px;
      position: relative;

      ${mediaQuery.xs} {
        display: none;
      }
    }

    .dropdown-toggle {
      margin-left: -5px;
    }
  }
`;
